import { stringify } from 'qs';
import api from '../config/api';
import { network } from '../utils';

const getFavorite = async (params) => {
  return await network({
    url: api.sales.favorite,
    method: 'get',
  });
};

const collect = async (data) => {
  return await network({
    url: api.sales.collect,
    method: 'post',
    data: stringify(data),
  });
};

const custom = async (data) => {
  return await network({
    url: api.sales.saveCustom,
    method: 'post',
    data: stringify(data),
  });
};

const getStockList = async (params) => {
  return await network({
    url: api.stock.stockListBySelect,
    method: 'get',
  });
};

const queryDelivery = async (params) => {
  return await network({ url: api.common.delivery, params, method: 'get' });
};

//查询有货和备货提醒的设置人数
const queryRemindNumber = async (params) => {
  return await network({ url: api.core.remindNumber, params, method: 'get' });
};

//设置有货和备货提醒
const saveRemind = async (data) => {
  return await network({
    url: api.core.saveRemind,
    method: 'put',
    data,
  });
};

const downLoadImg = async (url) => {
  return await network({
    url: `api/sys/file/url_download.do?url=${url}`,
    method: 'get',
  });
};

const downloadWord = async (projectNo, fileType) => {
  return await network({
    url: `api/biz/wm/downloadDrawing.do?itemCode=${projectNo}&fileType=${fileType}`,
    method: 'get',
    responseType: 'arraybuffer',
  });
};

export {
  getFavorite,
  collect,
  custom,
  getStockList,
  queryDelivery,
  queryRemindNumber,
  saveRemind,
  downLoadImg,
  downloadWord,
};
